const activationMessages = {
  'activation.input.button': '登録',
  'activation.message.error.1001': 'アクティベーションコードが一致しません',
  'activation.message.error.1002': '登録済みのアクティベーションコードです',
  'activation.message.error.others': 'アクティベーションコード登録エラーです',
  'activation.input.title': 'アクティベーションコードの入力',
};

export default activationMessages;
